import { Policy } from "../../components/PrivacyPolicy/Policy";

export default function PrivacyPolicy () {
    return (
        <Policy/>
    )
}